var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 29.5C30.125 29.931 29.9538 30.3443 29.649 30.6491C29.3443 30.9538 28.931 31.125 28.5 31.125H2.5C2.06902 31.125 1.6557 30.9538 1.35095 30.6491C1.04621 30.3443 0.875 29.931 0.875 29.5V12.4213C0.874829 12.1736 0.931253 11.9292 1.03996 11.7068C1.14867 11.4843 1.3068 11.2896 1.50225 11.1375L14.5022 1.02676C14.7875 0.804863 15.1386 0.684387 15.5 0.684387C15.8614 0.684387 16.2125 0.804863 16.4978 1.02676L29.4978 11.1375C29.6932 11.2896 29.8513 11.4843 29.96 11.7068C30.0687 11.9292 30.1252 12.1736 30.125 12.4213V29.5ZM13.875 18.125V27.875H17.125V18.125H13.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.359a0ee0ac5c004b30c62d4b4e8538e7.svg";
export { ForwardRef as ReactComponent };